import { render, staticRenderFns } from "./AttachmentsLoader.vue?vue&type=template&id=9d4458aa&lang=pug&"
import script from "./AttachmentsLoader.vue?vue&type=script&lang=ts&"
export * from "./AttachmentsLoader.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentsLoader.vue?vue&type=style&index=0&id=9d4458aa&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports